import React from 'react';

export default function Features() {
  const features = [
    { title: 'Contact Management', description: 'Organize and track all customer interactions in one place' },
    { title: 'Sales Pipeline', description: 'Visualize deals and move them through your sales process' },
    { title: 'Analytics & Reports', description: 'Get insights into sales performance and team productivity' },
    { title: 'Team Collaboration', description: 'Work together seamlessly with shared notes and tasks' }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">Everything You Need to Manage Customers</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="p-6 bg-gray-50 rounded-lg hover:shadow-lg hover:border-red-600 border-2 border-transparent transition">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
